//@ts-check
import React, { Component } from 'react';
import { observer } from "mobx-react";
import { action } from 'mobx';
import IconsContainer from "Utils/IconsContainer";
import 'Styles/commonComponents/ClearableInput.scss';

/**
 * @typedef {object} props
 * @property {string} value
 * @property {(val: string) => void} onChange
 * @property {() => void} clear
 * @property {string} placeholder
 * @extends {Component<props>}
 */

class ClearableInput extends Component {
    render() {
        return (
            <div className={"ClearableInput"}>
                <div className="ClearableInput-text">
                    <input placeholder={this.props.placeholder}
                        value={this.props.value}
                        onChange={action(e => this.props.onChange(e.target.value))} />
                </div>
                <div className={"ClearableInput-icon " + (this.props.value ? "" : "hidden")}
                     onClick={action(() => this.props.clear())}>
                    {IconsContainer.Get('ci-cross')}
                </div>
            </div>
        )
    }
};

export default observer(ClearableInput);